/*eslint-disable no-extend-native */
/**
 *    Legacy Polyfills
 *      -- Centralized here
 *      -- Still in use in the project !
 */

// Array.toString()
Object.defineProperty(Array.prototype, 'toString', function arrayToString() {
  return this.join(', ');
});

// String.format()
//  - "Hello {0}, I'm {1}".format ('you', 'me')
//  -> Hello you, I'm me
if (!String.prototype.format) {
  String.prototype.format = function stringFormat(...args) {
    return this.replace(
      /{(\d+)}/g,
      (match, number) =>
        typeof args[number] !== 'undefined' ? args[number] : match
    );
  };
}



// WEBPACK FOOTER //
// ./src/modules-es5/commons/polyfills/legacy.js